import React from 'react';

import AdminDictionaryList, { Pair } from '@dashboard/components/AdminDictionaryList';
import Link from '@dashboard/components/mui-atoms/Link';
import { useDomainNameVerificationQuery, usePlatformQuery } from '@dashboard/generated/wp/administrator';
import { Link as MuiLink } from '@mui/material';

type Props = {
  id: string;
};
export default function DomainNameVerificationShow({ id }: Props) {
  const { data } = useDomainNameVerificationQuery({ variables: { id } });
  const model = data?.DomainNameVerification;
  const platformId = model?.platformId;
  const { data: platformData } = usePlatformQuery({
    variables: { id: platformId ?? '' },
    skip: !platformId,
  });

  const platform = platformData?.Platform;

  return (
    <AdminDictionaryList>
      <Pair label="Created at" value={model?.createdAt} />
      <Pair
        label="Domain ID"
        value={model && <Link href={`/o/${model.platformId}/domain-names/${model.id}`}>{model.id}</Link>}
      />

      <Pair
        label="Domain name"
        value={
          model && (
            <MuiLink target="_blank" href={`https://${model.domainName}`}>
              https://{model.domainName}
            </MuiLink>
          )
        }
      />

      <Pair label="Billing email" value={platform?.billingEmailAddress} />
      <Pair label="Verification status" value={model?.status} />
      <Pair label="Approval status" value={model?.approvalStatus} />
      <Pair
        label="Platform"
        value={
          model && (
            <>
              {'['}
              <Link href={`/admin/o/${model.platformId}`}>Admin</Link>
              {'] '}
              <Link href={`/o/${model.platformId}`}>{model.platformId}</Link>
            </>
          )
        }
      />
    </AdminDictionaryList>
  );
}
